import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate } from "@angular/service-worker";
import { concat,interval,Subject} from 'rxjs';
import { first } from 'rxjs/operators';
  
@Injectable()
export class UpdateService {
  private _updateChangedSubject = new Subject<boolean>();
  updateChanged = this._updateChangedSubject.asObservable();

    constructor(appRef: ApplicationRef,public updates: SwUpdate) {
          // Allow the app to stabilize first, before starting polling for updates with `interval()`.
        const appIsStable$ = appRef.isStable.pipe(first(isStable => isStable === true));
        const intervalSec$ = interval(6 * 60 * 60 * 60);
        const everySecOnceAppIsStable$ = concat(appIsStable$, intervalSec$);
        everySecOnceAppIsStable$.subscribe(() => updates.checkForUpdate().then(() => console.log('timer checking for updates')));
    }
  
    public checkForUpdates(): void {
      console.log("checking for update");
      this.updates.available.subscribe(event => this.promptUser());
    }
  
    private promptUser(): void {
      this.updates.activateUpdate().then(() =>  this._updateChangedSubject.next(true) ); 
    }
}